import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import ordersQuery from '~/graphql/user/orders.gql';
import orderQuery from '~/graphql/user/order.gql';

function fetchCustomerOrderList(_x) {
  return _fetchCustomerOrderList.apply(this, arguments);
}

function _fetchCustomerOrderList() {
  _fetchCustomerOrderList = _asyncToGenerator(function* (context) {
    const response = yield context.app.apolloProvider.defaultClient.query({
      query: ordersQuery
    });
    return response.data;
  });
  return _fetchCustomerOrderList.apply(this, arguments);
}

function fetchCustomerOrder(_x2, _x3) {
  return _fetchCustomerOrder.apply(this, arguments);
}

function _fetchCustomerOrder() {
  _fetchCustomerOrder = _asyncToGenerator(function* (context, reference) {
    const locale = context.state.i18n.currentLocale.iso;
    const response = yield context.app.apolloProvider.defaultClient.query({
      query: orderQuery,
      variables: {
        reference,
        locale
      }
    });
    return response.data;
  });
  return _fetchCustomerOrder.apply(this, arguments);
}

function fetchCustomer(_x4) {
  return _fetchCustomer.apply(this, arguments);
}

function _fetchCustomer() {
  _fetchCustomer = _asyncToGenerator(function* (context) {
    const locale = context.state.i18n.currentLocale;
    const xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/ajax_customer_details.json");
    const {
      data
    } = yield context.$axios.get(xhrUri, {
      withCredentials: true
    });
    return data;
  });
  return _fetchCustomer.apply(this, arguments);
}

function addCartCustomizable(_x5, _x6) {
  return _addCartCustomizable.apply(this, arguments);
}

function _addCartCustomizable() {
  _addCartCustomizable = _asyncToGenerator(function* (context, payload) {
    const locale = context.state.i18n.currentLocale;
    const xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/custom/panier/").concat(payload);
    const {
      data
    } = yield context.$axios.get(xhrUri, {
      'axios-retry': {
        retries: 0
      }
    });
    return data;
  });
  return _addCartCustomizable.apply(this, arguments);
}

function addCart(_x7, _x8) {
  return _addCart.apply(this, arguments);
}

function _addCart() {
  _addCart = _asyncToGenerator(function* (context, payload) {
    const locale = context.state.i18n.currentLocale;
    const xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/").concat(payload.referenceEncoded, "/").concat(payload.quantity);
    const {
      data
    } = yield context.$axios.get(xhrUri, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      'axios-retry': {
        retries: 0
      }
    });
    return data;
  });
  return _addCart.apply(this, arguments);
}

function updateCart(_x9, _x10) {
  return _updateCart.apply(this, arguments);
}

function _updateCart() {
  _updateCart = _asyncToGenerator(function* (context, payload) {
    const locale = context.state.i18n.currentLocale;
    const xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/changer/").concat(payload.reference, "/").concat(payload.quantity);
    const {
      data
    } = yield context.$axios.get(xhrUri, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    return data;
  });
  return _updateCart.apply(this, arguments);
}

export { fetchCustomer, fetchCustomerOrderList, fetchCustomerOrder, addCart, addCartCustomizable, updateCart };